const registry: Record<string, any> = {};

const getPromise = (): any => {
  let resolve: (v: any) => void;
  let reject: (v: any) => void;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });

  return { promise, resolve: resolve!, reject: reject! };
};

export const addModalToRegistry = () => {
  const correlationId = Date.now();
  const promise = getPromise();
  registry[correlationId] = promise;
  return { correlationId, promise: promise.promise };
};

export const resolveModalInRegistry = (correlationId: any, payload: any) => {
  if (registry[correlationId]) {
    registry[correlationId].resolve(payload);
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete registry[correlationId];
  }
};
